import { Component, Input } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Observable } from 'rxjs';

import { EventTypes } from '@site-mate/dashpivot-shared-library';

import { EventsService } from 'app/shared/service/events/events.service';
import { GeolocationService } from 'app/shared/service/geolocation/geolocation.service';

@Component({
  selector: 'cc-signon-table-location',
  templateUrl: './signon-table-location.component.html',
  styleUrls: ['./signon-table-location.component.scss'],
})
export class SignonTableLocationComponent {
  @Input() point: { coordinates: [number, number] } | null = null;
  isGeoAPILoaded$: Observable<boolean> = this.geolocationService.isGeoAPILoaded$;
  GPSLocation: { lat: number; lng: number } | null = null;

  constructor(
    private readonly modalService: NgbModal,
    private readonly eventsService: EventsService,
    private readonly geolocationService: GeolocationService,
  ) {}

  ngOnInit() {
    this.setGPSLocation();
  }

  private setGPSLocation() {
    if (!this.point) {
      this.GPSLocation = null;
    } else {
      this.GPSLocation = { lat: this.point.coordinates[0], lng: this.point.coordinates[1] };
    }
  }

  logGoogleMapsUsage() {
    this.eventsService.trackEvent(EventTypes.GoogleMapsRequestFromSignonTableLocation);
  }

  open(content, event) {
    event.stopPropagation();
    this.modalService.open(content, { size: 'lg' });
  }
}
